// extracted by mini-css-extract-plugin
export var container = "_i7-1";
export var cornerButtonContainer = "_i7-6";
export var disabled = "_i7-2";
export var dragActive = "_i7-3";
export var fileContainer = "_i7-5";
export var hiddenInput = "_i7-4";
export var widthContainer = "_i7-0";